import { Component, Vue } from "vue-property-decorator";

@Component({
  render: c => c("router-view")
})
export default class VendorComponent extends Vue {}
